<template>
  <div style="position: absolute; top: 0; width: 100%; height: 100%; background: #f0f3f7">
    <!-- PC -->
    <div class="pcBanner">
      <div class="head">
        <div class='back_btn'
             @click='goStudy'>
          返回学习中心
        </div>
        <img class="img_12"
             style=""
             src="../../../assets/listImgs/111.png"
             alt="" />
      </div>
      <div class="banner">
        <div class="left">
          <div style="text-align: center">
            <img class="box12"
                 src="../../../assets/listImgs/heiTitle@2x.png"
                 alt="" />
          </div>
          <div class="box13">
            <div @click="tabClcik(1)"
                 :class="tabActive == '1' ? 'active' : 'noActive'"
                 style="display: flex; justify-content: center; align-items: center">
              <div class="box14 box101"
                  >
                <img v-if="tabActive == '1'"
                     class="imgBox"
                     src="../../../assets/listImgs/myKao@2x.png"
                     alt="" />
                <img class="imgBox"
                     v-else
                     src="../../../assets/listImgs/nomy@2x.png"
                     alt="" />
              </div>
              <div class="box14">我的考试</div>
            </div>

            <div @click="tabClcik(2)"
                 :class="tabActive == '2' ? 'active box15' : 'noActive box15'">
              <div class="box14 box101"
                   >
                <img class="imgBox"
                     v-if="tabActive == '2'"
                     src="../../../assets/listImgs/acjilu@2x.png"
                     alt="" />
                <img v-else
                     class="imgBox"
                     src="../../../assets/listImgs/jilu@2x.png"
                     alt="" />
              </div>
              <div class="box14">考试记录</div>
            </div>

            <!-- <div class="noActive"
               style="display: flex; justify-content: center; align-items: center; margin-top: 20px">
            <div>
              <img style="margin-top: 6px"
                   class="imgBox"
                   src="../../assets/listImgs/tongzhi@2x.png"
                   alt="" />
            </div>
            <div style="margin-left: 5px">通知消息</div>
          </div> -->
          </div>
        </div>

        <div class="center">
          <div></div>
          <div class="center_left"
               v-if="tabActive == '1'">
            <div v-if="examList.length == 0"
                 class="box16">暂无数据</div>
            <div v-else>
              <div v-for="(item, index) in examList"
                   :key="item.id">
                <div @click="tips(item, index)"
                     :class="active == index ? 'color1 tips' : 'tips color2'"
                     v-if="item.status !== '03'">
                  <div v-if="item.status !== '03'">
                    <div class="pos2"
                         v-if="item.sta == '01'">未开始</div>
                    <div class="pos4"
                         v-if="item.sta == '02'">进行中</div>
                    <div class="pos4"
                         v-if="item.sta == '03'">已结束</div>

                    <img :class="active == index ? 'img1' : 'img2'"
                         :src="active == index ? xuan : nox"
                         alt="" />
                    <div style="position: relative; z-index: 2; padding: 20px" class="box100">
                      <div style="font-family: Medium"
                           class="box17">
                        <div>{{ item.lrnExamQuiz.name }}</div>
                        <div class="box18"
                             :class="active == index ? 'color1' : 'color3'">
                          <div style="display: flex; align-items: center">
                            <div class="box19">
                              <img class="box20"
                                   src="../../../assets/listImgs/xuxian@2x.png"
                                   alt="" />
                            </div>
                            <div class="box21"
                                 style="">{{ item.lrnExamQuiz.timeopen }}&emsp;&emsp;开始</div>
                          </div>

                          <div style=""
                               class="box22">
                            <div class="box23"></div>
                            <div style=""
                                 class="box24">{{ item.lrnExamQuiz.timeclose }}&emsp;&emsp;结束</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div @click="tips(2)" :class="active == 2 ? 'color1 tips' : 'tips color2'">
            <div class="pos4">进行中</div>

            <img :class="active == 2 ? 'img1' : 'img2'" :src="active == 2 ? xuan : nox" alt="" />
            <div style="position: relative; z-index: 2; padding: 20px">
              <div style="font-size: 16px; font-family: Medium">
                <div>2023年线上继续教育通用测试卷一</div>
                <div style="margin-top: 15px" :class="active == 2 ? 'color1' : 'color3'">
                  <div style="display: flex; align-items: center">
                    <div style="position: relative; width: 9px; height: 9px; background: #5ad068; border-radius: 50%">
                      <img
                        style="width: 1px; height: 13px; position: absolute; bottom: -17px; left: 4px"
                        src="../../assets/listImgs/xuxian@2x.png"
                        alt=""
                      />
                    </div>
                    <div style="margin-left: 5px; font-family: Regular">2023-06-25 12:00&emsp;&emsp;开始</div>
                  </div>

                  <div style="display: flex; align-items: center; margin-top: 8px">
                    <div style="width: 9px; height: 9px; background: #fe5f5e; border-radius: 50%"></div>
                    <div style="margin-left: 5px; font-family: Regular">2023-06-25 16:00&emsp;&emsp;结束</div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          </div>

          <div class="center_left"
               v-else>
            <div v-if="examkList.length == 0"
                 class="box16">暂无数据</div>
            <div v-else>
              <div @click="tips(item, index)"
                   :class="active == index ? 'color1 tips' : 'tips color2'"
                   v-for="(item, index) in examkList"
                   :key="index">
                <div v-if="item.state == '03'"
                     class="pos2"
                     style="background-color: #8793a4">已考完</div>
                <div v-if="item.state == '04'"
                     class="pos2">批改中</div>
                <div v-if="item.state == '01'"
                     class="pos2">考试中</div>
                <div v-if="item.state == '05'"
                     class="pos2">已批改</div>
                <div v-if="item.state == '02'"
                     class="pos2">已保存</div>
                <img :class="active == index ? 'img1' : 'img2'"
                     :src="active == index ? xuan : nox"
                     alt="" />
                <div class="box26">
                  <div class="box27">
                    <div>{{ item.quizName }}</div>
                    <div class="box28">
                      <div>
                        <div :class="active == index ? 'color8' : 'color7'"
                        style="">考试成绩</div>
                        <div :class="item.qualified == '合格' ? 'color4 box29' : 'color6 box29'">{{ item.qualified }}</div>
                      </div>

                      <div :class="item.qualified == '合格' ? 'color4 box30' : 'color6 box30'"
                           style="">{{ item.grade }}分</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="deti"
               v-if="tabActive == '1'">
            <div v-if="examData.status !== '03'">
              <div class="soel">
                <img style=""
                     class="box31"
                     src="../../../assets/listImgs/center_bc@2x.png"
                     alt="" />
              </div>

              <div class="box32"
                   style="font-family: Bold; color: #4275f5"
                   v-if="examData.lrnExamQuiz">{{ examData.lrnExamQuiz.name }}</div>
              <div class="box34"
                   v-if="examData.lrnExamQuiz">
                考试时间：{{ examData.lrnExamQuiz.timeopen }} — {{ examData.lrnExamQuiz.timeclose }}
              </div>
              <div class="box33"
                   v-if="examData.lrnExamQuiz">考试时长：{{ examData.lrnExamQuiz.timelimit }}分钟</div>

              <div class="box33">考试题型：单选题, 多选题, 判断题, 简答题, 阅读理解题。</div>
              <div class="box33">考试须知：</div>
              <div v-if="examData.lrnExamQuiz">
                {{ examData.lrnExamQuiz.description }}
              </div>
              <div class="box33"
                   style="color: red">请完成学习后方可参加考试</div>
              <!-- <el-button
            @click="exam"
            style="margin-top: 25px; color: #fff; width: 160px; height: 50px; border-radius: 25px; background: #d3d3d3"
          >
            考试咯
          </el-button> -->

              <el-button v-if="examData.status == '01' || examData.status == '00' || examData.status == '04'"
                         @click="goExam(examData)"
                         style="background: #507df7"
                         class="box35">
                立即考试
              </el-button>
            </div>
            <div v-else>
              暂无考试~
            </div>
            <!-- <el-button
            v-else
            disabled
            style="margin-top: 25px; color: #fff; width: 160px; height: 50px; border-radius: 25px;
background: #D3D3D3;"
          >
            未到考试时间
          </el-button> -->
          </div>

          <div class="deti"
               v-else>
            <div class="soel">
              <img style="width: 150px; height: 120px; float: right; margin-top: 20px; margin-right: 20px"
                   src="../../../assets/listImgs/center_bc@2x.png"
                   alt="" />
            </div>

            <div style="font-family: Bold; color: #4275f5"
                 class="box32">{{ examData.quizName ? examData.quizName : '' }}</div>
            <div class="box34">考试时间：{{ examData.quizTime ? examData.quizTime : '' }}</div>
            <div class="box33">考试时长：{{ examData.timelimit ? examData.timelimit : '' }}分钟</div>
            <div class="box33">考试题型：单选题, 多选题, 判断题, 简答题, 阅读理解题。</div>
            <!-- <div class="box33">考试须知：</div> -->
            <!-- <div>{{ examData.quizduce  ? examData.quizduce : ''}}</div> -->
            <!-- <el-button
            @click="exam"
            style="margin-top: 25px; color: #fff; width: 160px; height: 50px; border-radius: 25px; background: #d3d3d3"
          >
            考试咯
          </el-button> -->

            <el-button @click="toPreview"
                       class="box35"
                       style="background: #507df7"> 考卷回顾 </el-button>

            <!--          <el-button @click="zhengti"
                     style="background: #507df7"
                     class="box35"> 在线征题 </el-button>-->
          </div>
        </div>

        <div class="right">
          <div style="display: flex; justify-content: center">
            <div style=""
                 class="box54">
              <img style="width: 100%; height: 100%"
              v-if="userData.userphoto!==null"
                   :src="userData.userphoto"
                   alt="" />
                   <img style="width: 100%; height: 100%"
                   v-else
                   src="../../../assets/img/headImg.png"
                   alt="" />
            </div>
          </div>
          <div style=""
               class="box38">
            <div style="display: flex">
              <div>{{ userData.realname || '' }}</div>
              <!-- <div>
              <img v-if="userData.sex == '01'"
                   class="box37"
                   style=""
                   src="../../assets/listImgs/nan@2x.png"
                   alt="" />
              <img v-else
                   class="box37"
                   style=""
                   src="../../assets/listImgs/nv@2x.png"
                   alt="" />
            </div> -->
            </div>
          </div>

          <div class="box55"></div>

          <!--        <div style=""
             class="box39">
          <div style=""
               class="box40">
            <div style="display: flex">
              <img style=""
                   class="box41"
                   src="../../assets/listImgs/phone@2x.png"
                   alt="" />
              手机号码
            </div>
            <div class="box42"
                 style="">{{ userData.mobile }}</div>
          </div>
        </div>-->

          <div style=""
               class="box39">
            <div class="box40">
              <div style="display: flex">
                <img class="box41"
                     src="../../../assets/listImgs/cnCode@2x.png"
                     alt="" />
                身份证号码
              </div>
              <div class="box42">{{ userData.cardno }}</div>
            </div>
          </div>

          <div class="box39">
            <div class="box40">
              <div style="display: flex">
                <!-- <img class="box41"
                   src="../../assets/listImgs/area@2x.png"
                   alt="" /> -->
                <!-- 所在地区 -->
              </div>
              <!-- <div class="box42">安徽省合肥市高新区创新产业园</div> -->
            </div>
          </div>

          <div class="box39">
            <div class="box40">
              <div style="display: flex">
                <!-- <img class="box41"
                   src="../../assets/listImgs/danwei@2x.png"
                   alt="" /> -->
                <!-- 单位名称 -->
              </div>
              <!-- <div class="box42">{{ userData.userAddress }}</div> -->
            </div>
          </div>

          <div class="shiX">
            <div style=""
                 class="box43">注意事项</div>

            <div class="box44">请仔细核对个人信息，如信息有误需及时反馈，以免影响个人成绩证明!</div>
          </div>

          <!-- <div class="back"
               @click="logout">
            <div style="display: flex">
              <div><img class="box45"
                     src="../../assets/listImgs/back@2x.png"
                     alt="" /></div>
              <div style=""
                   class="box46">退出登录</div>
            </div>
          </div> -->
        </div>
      </div>

      <div v-if="dialogVisible"
           style=""
           class="box47">
        <div class="dia">
          <img @click="dialogVisible = false"
               style=""
               class="box48"
               src="../../../assets/listImgs/close@2x.png"
               alt="" />
          <div class="box49"
               style="">承诺书</div>

          <div style=""
               class="box50">
            <div style="font-family: Medium">&emsp;&emsp;我郑重承诺：</div>
            <div>
              &emsp;&emsp;一、保证在网上报名和网上确认（现场确认）时，严格按照报考条件及相关政策要求选择填报志愿，如实、准确提交报考信息和各项材料。如提供虚假、错误信息或弄虚作假，本人承担由此造成的一切后果。
            </div>
            <div>&emsp;&emsp;二、自觉服从考试组织管理部门的统一安排，接受监考人员的管理、监督和检查。</div>
            <div>&emsp;&emsp;三、自觉遵守相关法律和考试纪律、考场规则，诚信考试，不作弊。</div>
            <div>&emsp;&emsp;四、考试时将会默认进入全屏，禁止退出全屏，否则会影响您的考试。</div>
          </div>
          <el-checkbox class="box36"
                       v-model="checked">我已仔细阅读承诺书，并同意</el-checkbox>
          <div @click="goExam"
               class="qBtn">同意并立即考试</div>
        </div>
      </div>
    </div>
    <!-- endPc -->

    <!-- phone -->
    <div class="phoneBanner">

    </div>
    <!-- endphone -->
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import nox from '../../../assets/listImgs/nox@2x.png';
import xuan from '../../../assets/listImgs/xuanzhong@2x.png';
import { mapMutations } from 'vuex';
import { toExamQuize, toExamUQDetail, logout, toPreview, findUQState, doLogin } from '../../../api/questions';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      active: 0,
      nox,
      xuan,
      dialogVisible: false, //承诺书弹框
      tabActive: '',
      examList: [], //我的考试列表
      userData: {}, //用户数据
      examkList: [], //试卷列表
      examData: {}, //考试数据
      url: '', //在线征题的url

      surl: '',
      webSocket: null, //
      checked: false, //承诺书勾选
      pcCenterUrl: ''
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    ...mapMutations('m_user', ['updateToken']),
    // getUrl() {
    //   getUrl({}).then(res => {
    //     // console.log(res);
    //   this.pcCenterUrl = res.data.data.pcCenterUrl;
    //   localStorage.setItem('url',this.pcCenterUrl)
    //   })
    // },
    goStudy() {
      this.$router.push({ path: '/studyMain' });

      // window.location.replace(this.pcCenterUrl + '?token=' + localStorage.getItem('token'));
    },
    //登录
    login(data) {
      doLogin(data).then(res => {
        ////console.log(res);
        if (res.data.token) {
          this.updateToken(res.data.token);
          //拿到密钥存在本地存储
          localStorage.setItem('token', res.data.token);

          this.tabClcik(1);
          this.getExamList();
        }
      });
    },
    //跳后台在线征题页面
    zhengti() {
      window.open(this.url);
    },
    //考卷回顾
    toPreview() {
      console.log(this.examkList[this.active]);
      if (this.examkList[this.active] == undefined) {
        this.$message('未选择试卷！');
        return false;
      }
      this.dialogVisible = false;
      console.log(this.active);
      this.$router.push({
        path: '/record',
        query: {
          id: this.examkList[this.active].uqdId
        }
      });
      // let data = {
      //   uqdId:this.examkList[this.active].uqdId
      // }
      // toPreview(data).then(res => {
      //   console.log(res);
      // })
    },
    //退出登录
    logout() {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          logout().then(res => {
            console.log(res);
          });
          this.$router.push('/');
          this.$message({
            type: 'success',
            message: '退出成功!'
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
    },
    //获取考试列表
    getExamList() {
      let _this = this;
      toExamQuize({}).then(res => {
        _this.examList = res.data.data.examUqList;
        console.log(_this.examList);
        _this.userData = res.data.data.user;
        _this.pcCenterUrl = res.data.data.pcCenterUrl;
        localStorage.setItem('url', _this.pcCenterUrl);
        //      _this.surl = 'wss://' + res.data.data.url + '/api/'+ 'websocket/' + _this.userData.id;

        //       _this.surl = 'ws://' + res.data.data.url + '/'+ 'websocket/' + _this.userData.id;
        //
        //      setTimeout(() => {
        //        _this.webSocket = new WebSocket(_this.surl);
        //        _this.webSocket.onclose = function (event) {
        //          console.log('WebSocket连接关闭'); // 同上
        //          //连接关闭的回调方法
        //          setTimeout(() => {
        //            _this.webSocket = new WebSocket(_this.surl);
        //          }, 5000); // 5秒后重连
        //        };
        //        _this.webSocket.onopen = function (event) {
        //          console.log('建立连接'); //
        //        };
        //        _this.webSocket.onmessage = function (event) {
        //          console.log(event.data);
        //          _this.$message({
        //            showClose: true,
        //            type: 'warning',
        //            message: event.data,
        //            duration: '0'
        //          });
        //        };
        //        _this.webSocket.onerror = function (event) {
        //          console.log('websocket发生错误');
        //        };
        //      }, Math.round(Math.random() * 10) * 1000);

        _this.tips(this.examList[0], 0);
      });
    },
    //tab栏
    tabClcik(id) {
      console.log(id);
      this.tabActive = id;

      if (id == 2) {
        toExamUQDetail({}).then(res => {
          console.log(res);
          this.examkList = res.data.data.examUQDetailList;
          this.url = res.data.data.url;
          this.tips(this.examkList[0], 0);
        });
      } else {
        this.tips(this.examList[0], 0);
      }
    },
    tips(item, idx) {
      this.active = idx;
      console.log(item);
      if (item !== undefined) {
        this.examData = item;
      }
    },
    //参加考试
    goExam(item) {
      findUQState({ uqId: item.id }).then(res => {
        console.log(res);
        if (res.data.data.sta == '01') {
          this.$router.push({
            path: '/examDetail',
            query: {
              id: this.examList[this.active].id
            }
          });
        } else {
          this.$message({
            type: 'info',
            message: '您无法参加该考试！'
          });
          this.getExamList();
        }
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    // this.getUrl()
    // if (this.$route.query.token) {
    //   // 拿到密钥存在本地存储
    //   this.updateToken(this.$route.query.token);
    //   //拿到密钥存在本地存储
    //   localStorage.setItem('token', this.$route.query.token);

    // }
    if (this.$route.query.table) {
      this.tabClcik(2);
    } else {
      this.tabClcik(1);
    }
    setTimeout(() => {
      this.getExamList();
    }, 500);
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    window.addEventListener(
      'storage',
      () => {
        this.$confirm('禁止打开多标签页！', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          showClose: false,
          distinguishCancelAndClose: true,
          showCancelButton: false,
          closeOnClickModal: false,
          closeOnPressEscape: false
        })
          .then(() => {
            window.open('about:blank', '_self');
            window.close();
          })
          .catch(() => {});
      },
      false
    );
    localStorage.setItem('Sentinel', Math.random());
  },
  destroyed() {
    // this.webSocket.close();
  },
  beforeCreate() {
    // this.webSocket.close();
  }, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
// @media (min-width: 768px) {
  .phoneBanner {
    display: none;
  }
  .box101 {
    margin-top: 12px !important;
  }
  .box100 {
    width: 357px;
    height: 126px;
    display: flex;
    align-items: center;
  }
  .img_12 {
    width: 144px;
    height: 25px;
  }
  .box12 {
    width: 144px;
    height: 25px;
  }
  .box13 {
    margin-top: 30px;
  }
  .box14 {
    margin-left: 5px;
    margin-top: 6px;
  }
  .box15 {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
  }
  .box16 {
    text-align: center;
    font-size: 17px;
    font-family: Medium;
    line-height: 700px;
  }
  .box17 {
    font-size: 16px;
  }
  .box18 {
    margin-top: 15px;
  }
  .box19 {
    position: relative;
    width: 9px;
    height: 9px;
    background: #5ad068;
    border-radius: 50%;
  }
  .box20 {
    width: 1px;
    height: 13px;
    position: absolute;
    bottom: -17px;
    left: 4px;
  }
  .box21 {
    margin-left: 5px;
    font-family: Regular;
  }
  .box22 {
    display: flex;
    align-items: center;
    margin-top: 8px;
  }
  .box23 {
    width: 9px;
    height: 9px;
    background: #fe5f5e;
    border-radius: 50%;
  }

  .box24 {
    margin-left: 5px;
    font-family: Regular;
  }
  .box25 {
    width: 9px;
    height: 9px;
    background: #fe5f5e;
    border-radius: 50%;
  }
  .box26 {
    position: relative;
    z-index: 2;
    padding: 20px;

  }
  .box27 {
    font-size: 16px;
    font-family: Medium;
  }

  .box28 {
    display: flex;
    justify-content: space-between;
    margin-top: 16px;
  }
  .box29 {
    font-size: 14px;
    margin-top: 8px;
  }
  .box30 {
    font-family: Bold;
    font-size: 26px;
    margin-top: 8px;
  }
  .box31 {
    width: 150px;
    height: 120px;
    float: right;
    margin-top: 20px;
    margin-right: 20px;
  }
  .box32 {
    font-size: 20px;
  }
  .box33 {
    margin-top: 8px;
  }
  .box34 {
    margin-top: 12px;
  }
  .box35 {
    margin-top: 25px;
    color: #fff;
    width: 160px;
    height: 50px;
    border-radius: 25px;
  }
  .box36 {
    margin-top: 12px;
  }
  .box37 {
    width: 72px;
    height: 72px;
    box-shadow: 0px 4px 15px #e5e5e5;
    border-radius: 50%;
    overflow: hidden;
  }
  .box38 {
    margin-top: 15px;
    font-size: 18px;
    display: flex;
    justify-content: center;
  }
  .box36 {
    margin-top: 12px;
  }
  .box37 {
    width: 24px;
    height: 18px;
    margin-left: 4px;
    margin-top: 3px;
  }

  .box39 {
    margin-top: 29px;
  }
  .box40 {
    font-size: 16px;
    color: #272748;
  }
  .box41 {
    width: 16px;
    height: 16px;
    margin-top: 4px;
    margin-right: 4px;
  }
  .box42 {
    color: #8793a4;
    font-size: 14px;
    font-family: Regular;
    margin-top: 3px;
  }
  .box43 {
    font-size: 14px;
    text-align: center;
  }
  .box44 {
    margin-top: 10px;
  }
  .box45 {
    width: 16px;
    height: 16px;
    margin-top: 17px;
  }
  .box46 {
    margin-left: 8px;
  }
  .box47 {
    position: absolute;
    top: 0;
    z-index: 9;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
  }
  .box48 {
    width: 16px;
    height: 16px;
    position: absolute;
    right: 16px;
    top: 16px;
    cursor: pointer;
  }
  .box49 {
    text-align: center;
    font-size: 18px;
    font-family: Bold;
  }
  .box50 {
    margin-top: 20px;
  }
  .box51 {
    margin-left: 8px;
  }
  .box52 {
    margin-left: 8px;
  }
  .box53 {
    margin-left: 8px;
  }
  .box54 {
    width: 72px;
    height: 72px;
    box-shadow: 0px 4px 15px #e5e5e5;
    border-radius: 50%;
    opacity: 1;
    overflow: hidden;
  }
  .box55 {
    width: 100%;
    height: 1px;
    background: #eee;
    margin-top: 28px;
  }

  .imgBox {
    width: 16px;
    height: 16px;
  }
  .active {
    width: 200px;
    height: 52px;
    background: #4275f5;
    opacity: 1;
    border-radius: 12px;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
  }
  .noActive {
    width: 200px;
    height: 52px;
    background: #fff;
    opacity: 1;
    border-radius: 12px;
    color: #8793a4;
    font-size: 16px;
    cursor: pointer;
  }
  .dia {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 500px;
    height: 450px;
    background: #ffffff;
    border-radius: 12px;
    padding: 24px;
    font-size: 16px;
    font-family: Regular;
  }
  .qBtn {
    width: 180px;
    height: 50px;
    background: #4275f5;
    opacity: 1;
    border-radius: 25px;
    color: #fff;
    font-size: 16px;
    text-align: center;
    cursor: pointer;
    line-height: 50px;
    margin: 23px auto auto auto;
  }
  .head {
    position: relative;
    width: 100%;
    height: 60px;
    background: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    background: url('../../../assets/listImgs/head_bc@2x.png') 100% 100%;
    .back_btn {
      font-size: 14px;
      width: 120px;
      height: 40px;
      color: #fff;
      text-align: center;
      line-height: 40px;
      border-radius: 6px;
      background: #fe5f5e;
      cursor: pointer;
      position: absolute;
      left: 80px;
      top: 10px;
    }
  }
  .banner {
    margin-top: 15px;
    display: flex;
    padding: 0 100px;
    .left {
      width: 240px;
      height: 800px;
      background: #ffffff;
      opacity: 1;
      border-radius: 12px;
      padding: 30px 20px;
      font-family: Medium;
    }
    .center {
      width: 1220px;
      height: 800px;
      background: #fff;
      opacity: 1;
      border-radius: 12px;
      margin-left: 10px;
      display: flex;
      .center_left {
        padding: 10px 0 0 20px;
        height: 800px;
        width: 410px;
        overflow-y: scroll;
        .tips {
          width: 350px;
          height: 126px;
          margin-top: 20px;
          position: relative;

          cursor: pointer;
        }
        .color1 {
          color: #4275f5;
        }
        .color2 {
          color: #333333;
        }
        .color3 {
          color: #8793a4;
        }
        .img1 {
          width: 357px;
          height: 126px;
          position: absolute;
          top: 0;
          z-index: 1;
        }
        .img2 {
          width: 350px;
          height: 126px;
          position: absolute;
          top: 0;
          z-index: 1;
        }
        .pos2 {
          position: absolute;
          top: 1px;
          right: 0px;
          z-index: 2;
          line-height: 24px;
          text-align: center;
          font-size: 12px;
          color: #fff;
          width: 64px;
          height: 24px;
          background: #5ad068;
          border-radius: 0px 12px 0px 12px;
        }

        .pos4 {
          position: absolute;
          top: 1px;
          right: 0px;
          z-index: 2;
          line-height: 24px;
          text-align: center;
          font-size: 12px;
          color: #fff;
          width: 64px;
          height: 24px;
          background: #4275f5;
          border-radius: 0px 12px 0px 12px;
        }
      }
      .center_left::-webkit-scrollbar {
        width: 4px;
      }
      .center_left::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background: rgba(0, 0, 0, 0.2);
      }
      .center_left::-webkit-scrollbar-track {
        border-radius: 0;
        background: rgba(0, 0, 0, 0.1);
      }

      .deti {
        margin-left: 30px;
        padding: 30px 20px 0 0;
        font-family: Medium;
        color: #272748;
        font-size: 14px;
        position: relative;
        z-index: 2;
        width: 820px;
        .soel {
          width: 100%;
          position: absolute;
          top: 0;
          height: 156px;
          border-radius: 12px;
          z-index: -1;
          background: linear-gradient(187deg, #dde6ff 0%, #ffffff 39%);
        }
      }
    }
    .right {
      width: 240px;
      height: 800px;
      background: #ffffff;
      border-radius: 12px;
      margin-left: 10px;
      padding: 30px 20px;
      font-family: Medium;
      color: #272748;

      .shiX {
        margin-top: 70px;
        width: 200px;
        height: 125px;
        background: rgba(254, 95, 94, 0.08);
        border-radius: 12px;
        padding: 20px;
        color: #fe5f5e;
        font-size: 12px;
      }
      .back {
        width: 160px;
        height: 50px;
        border: 1px solid #fe5f5e;
        border-radius: 12px;
        line-height: 50px;
        text-align: center;
        font-size: 16px;
        color: #fe5f5e;
        display: flex;
        cursor: pointer;
        justify-content: center;
        margin-left: 20px;
        margin-top: 40px;
      }
    }
  }
  .color4 {
    color: #5ad068;
  }
  .color5 {
    color: #fff;
  }

  .color6 {
    color: #fe5f5e;
  }
  .color7 {
    color: #8793a4;
  }
  .color8 {
    color: #4275f5;
    font-size: 14px
  }

  .faceCamera {
    background: gray;
    margin: 0 auto;
    border-radius: 4px;
    overflow: hidden;
    -webkit-border-radius: 4px;
    left: 0;
    top: -8.5%;
    right: 0;
    bottom: 0;
    padding-top: 50px;
    display: none;
    position: fixed;
    z-index: 999999999;
    text-align: center;
    width: 93%;
    height: 530px;
    margin-top: 65px;
  }
// }

// @media (max-width: 768px) { 
//   .pcBanner {
//     display: none;
//   }
  
// }
</style>
